function TextParagraph({
  content,
  style,
  baseBodyClass = "body-b2",
  headingClass = "",
  bodyClass = "",
}) {
  const { heading, bodyText } = content;
  return (
    <>
      <h3 className={headingClass}>{heading}</h3>
      <div className={`${baseBodyClass} ${bodyClass}`} style={style}>
        {bodyText}
      </div>
    </>
  );
}

export default TextParagraph;
